import { CheckIcon } from "@heroicons/react/outline";

import { cn } from "@/lib/utils";

interface MultiSelectCheckProps {
  selected: boolean;
}

const MultiSelectCheck = ({ selected }: MultiSelectCheckProps) => (
  <span
    className={cn(
      "mr-2 flex h-4 w-4 shrink-0 items-center justify-center rounded border",
      selected ? "border-blue-500 bg-blue-500 text-white" : "border-gray-300 bg-white",
    )}
  >
    {selected && <CheckIcon className="h-3 w-3" />}
  </span>
);

export default MultiSelectCheck;
